<template>
  <div class="goodsManageSet">
    <div class="banner">
      <img src="../../../assets/images/banner1.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon">
        <i class="iconfont icon-shangpinsku"></i>
      </div>
      <div class="breadcrumb_item">SKU管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">商品管理</div>
    </div>

    <div class="main_content">
      <div class="tit">Ai辅助图设置</div>
      <div class="block">
        <div class="block_item" v-if="false">
          <h1><span class="mark">*</span>AI辅助图01</h1>
          <div class="radio_box">
            <van-radio-group direction="horizontal" v-model="formData.aipic1_site" class="flex-rowc">
              <van-radio name="正面">正面</van-radio>
              <!-- <van-radio name="背面">背面</van-radio>
              <van-radio name="局部细节">局部细节</van-radio> -->
            </van-radio-group>
          </div>
        </div>
        <div class="block_item">
          <h1><span class="mark">*</span>产品正面</h1>
          <div class="img_box">
            <van-uploader
              v-model="fileList"
              @click-upload="clickUpload(1)"
              @delete="deleteImg(1)"
              :before-read="beforeRead"
              :after-read="afterRead"
              :max-count="1"
            />
          </div>
        </div>
      </div>

      <div class="block"> 
        <div class="block_item" v-if="false">
          <h1><span class="mark">*</span>AI辅助图02</h1>
          <div class="radio_box">
            <van-radio-group direction="horizontal" v-model="formData.aipic2_site" class="flex-rowc">
              <!-- <van-radio name="正面">正面</van-radio> -->
              <van-radio name="背面">背面</van-radio>
              <!-- <van-radio name="局部细节">局部细节</van-radio> -->
            </van-radio-group>
          </div>
        </div>
        <div class="block_item">
          <h1><span class="mark">*</span>产品背面</h1>
          <div class="img_box">
            <van-uploader
              v-model="fileList1"
              @click-upload="clickUpload(2)"
              @delete="deleteImg(2)"
              :before-read="beforeRead"
              :after-read="afterRead"
              :max-count="1"
            />
          </div>
        </div>
      </div>

      <div class="block">
        <div class="block_item" v-if="false">
          <h1><span class="mark">*</span>AI辅助图03</h1>
          <div class="radio_box">
            <van-radio-group direction="horizontal" v-model="formData.aipic3_site" class="flex-rowc">
              <!-- <van-radio name="正面">正面</van-radio>
              <van-radio name="背面">背面</van-radio> -->
              <van-radio name="局部细节">局部细节</van-radio>
            </van-radio-group>
          </div>
        </div>
        <div class="block_item">
          <h1><span class="mark">*</span>产品局部细节</h1>
          <div class="img_box">
            <van-uploader
              v-model="fileList2"
              @click-upload="clickUpload(3)"
              @delete="deleteImg(3)"
              :before-read="beforeRead"
              :after-read="afterRead"
              :max-count="1"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="primary-button" @click="handleSubmit">保存确认</div>

    <div class="primary-button return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i>返回
    </div>
  </div>
</template>

<script>
import {
  getCommidityDetail,
  editCommidity,
  uploadImage,
  encryptstringview,
} from "../../../api/api";
import { mapState } from "vuex";
export default {
  name: "cAiImages",
  data() {
    return {
      radio: "",
      searchText: "",
      isShowStyle: false,
      scrollTop: 0,

      isType: 1,

      fileList: [],
      fileList1: [],
      fileList2: [],

      cmid: "",
      formData: {
        Method: "ams_shop_commodity_edit",
        id: "",
        aipic1_site: "正面",
        aipic1: "",
        aipic2_site: "背面",
        aipic2: "",
        aipic3_site: "局部细节",
        aipic3: "",
      },
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList } = this.$store.state;
    let { name } = this.$route;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.cmid = id;
        this.getDetail();
      } else {
        this.$router.back();
      }
    },

    getDetail() {
      let { cmid } = this;
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getCommidityDetail({ id: cmid }).then((res) => {
        this.formData.id = res.id ? res.id : "";
        // this.formData.aipic1_site = res.aipic1_site ? res.aipic1_site : "";
        this.formData.aipic1 = res.aipic1 ? res.aipic1 : "";
        // this.formData.aipic2_site = res.aipic2_site ? res.aipic2_site : "";
        this.formData.aipic2 = res.aipic2 ? res.aipic2 : "";
        // this.formData.aipic3_site = res.aipic3_site ? res.aipic3_site : "";
        this.formData.aipic3 = res.aipic3 ? res.aipic3 : "";

        if (res.aipic1 != "") {
          this.fileList.push({ url: res.aipic1 });
        }
        if (res.aipic2 != "") {
          this.fileList1.push({ url: res.aipic2 });
        }
        if (res.aipic3 != "") {
          this.fileList2.push({ url: res.aipic3 });
        }
        Toast.clear();
      });
    },

    // 获得焦点
    inputFocus(e) {
      this.scrollTop = "-" + (e.srcElement.getBoundingClientRect().top - 200);
      this.isShowStyle = true;
    },
    // 失去焦点
    inputBlur() {
      this.isShowStyle = false;
    },
    handleReturn() {
      history.back();
    },

    // 图片上传
    clickUpload(type) {
      this.isType = type;
    },
    // 删除图片
    deleteImg(isType) {
      if (isType == 1) {
        this.formData.aipic1 = "";
      } else if (isType == 2) {
        this.formData.aipic2 = "";
      } else if (isType == 3) {
        this.formData.aipic3 = "";
      }
    },
    // 图片上传之前处理
    beforeRead(file) {
      const imgformat = /image\/(png|jpg|jpeg)$/;
      if (!imgformat.test(file.type)) {
        this.$toast.fail("请上传 jpg/png 格式图片");
        return false;
      }
      return true;
    },
    // 检测图片的宽高
    checkWidthAndHeight(file) {
      return new Promise((resolve, reject) => {
        let { isType } = this;
        let img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = function () {
          let width = img.width;
          var height = img.height;
          console.log("当前图片的宽高:" + width, height);
          if (isType == 1) {
            if (width == 500 && height == 500) {
              reject(true);
            } else {
              resolve(false);
            }
          }
        };
      });
    },
    // 图片上传后处理
    afterRead(e) {
      let { isType } = this;
      var formData = new FormData();
      formData.append("imgfile", e.file);
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
        duration: 0,
      });
      uploadImage(formData).then((res) => {
        if (res.result) {
          if (isType == 1) {
            this.formData.aipic1 = res.url;
          } else if (isType == 2) {
            this.formData.aipic2 = res.url;
          } else if (isType == 3) {
            this.formData.aipic3 = res.url;
          }
          Toast.clear();
        } else {
          this.$toast.fail(res.message || "服务器报错，请稍后～");
          Toast.clear();
        }
      });
    },

    handleSubmit() {
      let { formData } = this;
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      // formData.img = this.imgSplit(formData.img);
      // formData.banner = this.imgSplit(formData.banner);
      // formData.banner2 = this.imgSplit(formData.banner2);
      // formData.banner3 = this.imgSplit(formData.banner3);
      // formData.banner4 = this.imgSplit(formData.banner4);
      // formData.banner5 = this.imgSplit(formData.banner5);
      if (formData.aipic1_site == "") {
        this.$toast("请选择AI辅助图01-类别");
        return;
      }
      if (formData.aipic1 == "") {
        this.$toast("请上传AI辅助图01");
        return;
      }
      if (formData.aipic2_site == "") {
        this.$toast("请选择AI辅助图02-类别");
        return;
      }
      if (formData.aipic2 == "") {
        this.$toast("请上传AI辅助图02");
        return;
      }
      if (formData.aipic3_site == "") {
        this.$toast("请选择AI辅助图03-类别");
        return;
      }
      if (formData.aipic3 == "") {
        this.$toast("请上传AI辅助图03");
        return;
      }
      editCommidity(formData).then((res) => {
        let data = res;
        if (data.result) {
          setTimeout(() => {
            Toast.clear();
            this.$toast.success(data.message);
          }, 500);
          // setTimeout(() => {
          //   history.back();
          // }, 1500);
        } else {
          Toast.clear();
          this.$toast.fail(data.message || "服务器报错，请稍后～");
        }
      });
    },
    // 图片路径的分割
    imgSplit(url) {
      if (url != "") {
        if (url.indexOf("upload")) {
          let splitArr = url.split("/upload/");
          return splitArr[splitArr.length - 1];
        } else if (url.indexOf("Upload")) {
          let splitArr = url.split("/Upload/");
          return splitArr[splitArr.length - 1];
        }
      } else {
        return "";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  padding-bottom: 420px;
  .breadcrumb {
    padding-bottom: 60px;
  }
  .main_content {
    .tit {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .block {
      margin-bottom: 80px;
      .block_item {
        margin-bottom: 30px;
        /deep/.van-uploader__preview {
          margin: 0;
        }
      }
      h1 {
        text-align: center;
        font-weight: 400;
        margin-bottom: 20px;
        font-size: 30px;
      }
      .img_box {
        margin: auto;
        margin-top: 40px;
        text-align: center;
      }
      p {
        font-size: 22px;
        text-align: center;
        &.red {
          color: #ff0012;
        }
      }
    }
  }
}
</style>